import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTenderFolders } from '~src/services/api';
import { DbTenderFolder } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';
import { useProject } from './useProject';

interface UseTenderFoldersParams {
  favourites?: boolean;
  before?: number;
  search_name?: string;
  search_description?: string;
  as_admin?: boolean;
  after?: number;
  show_deleted?: boolean;
  tender_id_or_unassigned?: string;
}
export const useTenderFolders = (
  {
    favourites,
    before,
    search_name,
    search_description,
    as_admin,
    show_deleted,
    after,
    tender_id_or_unassigned,
  }: UseTenderFoldersParams = {},
  queryConfig: QueryConfig<DbTenderFolder[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const archiveSettings = useArchiveSettings();
  const projectQuery = useProject();

  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on &&
    (projectQuery?.data?.is_tender_admin || projectQuery?.data?.is_superuser);

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<DbTenderFolder[], AxiosError>(
    [
      'tenderFolders',
      {
        projectId: String(projectId),
        favourites,
        before,
        search_name,
        search_description,
        as_admin,
        after,
        show_deleted,
        tender_id_or_unassigned,
      },
    ],
    loadTenderFolders,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId && isTenderingOn,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
